export const isWholeNumber = (num) => num % 1 === 0;
//# sourceMappingURL=is-whole-number.js.map